import script from "./shangcaixq1.vue?vue&type=script&setup=true&lang=js"
export * from "./shangcaixq1.vue?vue&type=script&setup=true&lang=js"

import "./shangcaixq1.vue?vue&type=style&index=0&id=66a534c8&lang=less&scoped=true"
script.__scopeId = "data-v-66a534c8"

export default script